import { StarsLink } from '@ps/web-shared-ui';
import classNames from 'clsx';
import React from 'react';

import EmailIcon from '@swf/core/assets/icons/alternates/email.svg';

// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import styles from '../SocialShareButtons.scss';

interface Props {
  iconStyle?: React.CSSProperties;
  body: string;
  onClick(e: React.MouseEvent): void;
}

const EmailShareButton: React.FC<Props> = ({ body, onClick, iconStyle }) => (
  <StarsLink
    data-track-id="RAF_Email"
    className={classNames(styles.shareButton, styles.email)}
    href={`mailto:?body=${body}`}
    onClick={onClick}
  >
    <EmailIcon style={iconStyle} />
  </StarsLink>
);

export default EmailShareButton;
